import React, { Component } from "react";
import CustomizedSelect from "./customizedSelect";
import { Input } from "../../forms/input";
import Signbutton from "../../forms/button";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import { YES, SWP } from "../../../store/types";
import {
  swpOptions,
  CalcSIPEnddt,
  getMinimumAmount,
  saveTransactionDetails,
} from "../../../store/actions";
import { NEW_TRANSACTION_URL } from ".";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import { textAlign } from "@material-ui/system";
import { BajajFund } from "../nav";
class Swp extends Component {
  constructor(props) {
    super(props);
    const { fundList } = this.props;
    // const funds = fundList.reduce((prev, curr) => {
    //   const findIndex =
    //     prev.findIndex((fund) => fund.Fund === curr.Fund) !== -1;
    //   if (!findIndex) {
    //     return [...prev, { Fund: curr.Fund, FundDesc: curr.FundDesc }];
    //   }
    //   return prev;
    // }, []);

    this.state = {
      // funds,
      minAmountValue: { value: "" },
      fund: { value: { value: "189" } },
      folios: [],
      folio: { value: "" },
      schemes: [],
      scheme: { value: "" },
      swpOption: { value: "" },
      swpOptions: [],
      swpFrequency: { value: "" },
      swpFrequencyOptions: [],
      withdrawals: { value: "" },
      minAmountValue: { value: "" },
      sipDay: { value: "" },
      sipStartDate: { value: "" },
      sipEndDate: { value: "" },
      amount: { value: "" },
      sipCycle: [],
    };
  }
  handleFundChange = (value) => {
    if (!value) {
      this.setState({
        fund: { value: "" },
        folios: [],
        folio: { value: "" },
        schemes: [],
        scheme: { value: "" },
        swpOption: { value: "" },
        swpOptions: [],
        swpFrequency: { value: "" },
        swpFrequencyOptions: [],
        withdrawals: { value: "" },
        sipDay: { value: "" },
        sipStartDate: { value: "" },
        sipEndDate: { value: "" },
        amount: { value: "" },
        sipCycle: [],
      });
    } else if (value.value === this.state.fund.value.value) {
      return;
    } else {
      const fund = !!value ? value.value : "";
      const folios = this.props.fundList.reduce((prev, curr) => {
        if (curr.sFlag === YES && curr.Fund === fund) {
          return [...prev, curr.Acno];
        }
        return prev;
      }, []);
      this.setState({
        fund: { value },
        folios: Array.from(new Set(folios)),
        folio: { value: "" },
        scheme: { value: "" },
        withdrawals: { value: "" },
        swpFrequency: { value: "" },
      });
    }
  };

  async componentDidMount() {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
    const { transactionDetails } = this.props;
    if (Object.keys(transactionDetails).length > 0) {
      this.setState(transactionDetails);
      return;
    }
    this.getfolios();
  }

  getfolios = () => {
    const folios = this.props.fundList.reduce((prev, curr) => {
      if (curr.sFlag === YES && curr.Fund.trim() === "189") {
        return [...prev, curr.Acno];
      }
      return prev;
    }, []);
    this.setState({
      fund: { value: { value: "189" } },
      folios: Array.from(new Set(folios)),
      folio: { value: "" },
      scheme: { value: "" },
      withdrawals: { value: "" },
      swpFrequency: { value: "" },
    });
  };

  handleFolioChange = async (value) => {
    const folio = !!value ? value.value : "";
    const schemes = !!value ? this.schemes(folio) : [];
    // const banks = this.props.bankDetails.filter(item => item.foliono === folio);
    this.setState({
      folio: { value },
      schemes,
      scheme: { value: "" },
    });
  };
  schemes = (folio) => {
    return this.props.fundList.reduce((prev, curr) => {
      if (curr.Fund === this.state.fund.value.value && curr.Acno === folio) {
        return [...prev, curr];
      }
      return prev;
    }, []);
  };

  handleSchemeChange = async (value) => {
    if (!value) {
      this.setState({
        swpOption: { value: "" },
        swpOptions: [],
        swpFrequency: { value: "" },
        swpFrequencyOptions: [],
        withdrawals: { value: "" },
        sipDay: { value: "" },
        sipStartDate: { value: "" },
        sipEndDate: { value: "" },
        amount: { value: "" },
        sipCycle: [],
      });
    } else if (
      !!value &&
      !!this.state.scheme.value.value &&
      value.value.SchDesc === this.state.scheme.value.value.SchDesc
    ) {
      return;
    } else {
      if (value.value.BalUnits === 0) {
        this.setState({
          folio: {
            value: "",
            isError: true,
            errorMessage: "SWP in zero balance folios is not allowed",
          },
          scheme: {
            value: "",
          },
        });
      } else {
        const params = {
          fund: this.state.fund.value.value,
          opt: "SWPW",
          customfund: "189",
        };
        let swpOptionsResponse = [];
        const response = await this.props.swpOptions(params);
        if (response) {
          swpOptionsResponse = response.Dtinformation;
        }
        this.setState({
          scheme: { value },
          swpOptions: swpOptionsResponse,
        });
        this.handleSwpOptonChange({ target: { value: swpOptionsResponse[0] } });
      }
    }
  };
  handleSwpOptonChange = async (event) => {
    if (
      !!this.state.swpOption.value &&
      event.target.value.code === this.state.swpOption.value.code
    ) {
      return;
    } else {
      const swpOption = event.target.value;
      const params = {
        opt: "SWF",
        fund: this.state.fund.value.value,
      };
      const response = await this.props.swpOptions(params);
      const swpFrequencyOptionsResponse = response.Dtinformation;

      this.setState({
        swpOption: { value: swpOption },
        withdrawals: { value: "" },
        swpFrequency: { value: "" },
        swpFrequencyOptions: swpFrequencyOptionsResponse,
      });
    }
  };

  handleSwpFrequencyChange = async (event) => {
    const swpFrequency = event.target.value;
    if (!!swpFrequency) {
      const minParams = {
        Fund: this.state.fund.value.value,
        Scheme: this.state.scheme.value.value.Sch,
        Trtype: "SWP",
        Frequency: swpFrequency,
      };
      const response = await this.props.getMinimumAmount(minParams);
      if (response) {
        const { DtData } = response;
        this.setState({
          minAmountValue: {
            value: DtData[0].minamt
          },
        })
      }
    }

    const params = {
      opt: "SWPD",
      fund: this.state.fund.value.value,
      astscheme:
        !!event.target.value && !!event.target.value.FrequencyDescription
          ? event.target.value.FrequencyDescription
          : "",
    };
    const response = await this.props.swpOptions(params);
    const sipCycleResponse = response.Dtinformation;

    this.setState({
      swpFrequency: { value: swpFrequency },
      sipDay: { value: "" },

      sipStartDate: { value: "" },
      sipEndDate: { value: "" },
      sipCycle: sipCycleResponse,
      minAmountValue: {
        value: event.target.value.FrequencyID === "Yearly" ? 1000 : 500,
      },
    });
  };

  handleNoOfWithDrawals(event) {
    if (event.target.value.length <= 3 && !!event.target.value) {
      if (parseFloat(event.target.value) <= 999 && event.target.value !== "0") {
        this.setState({
          withdrawals: {
            value: parseFloat(event.target.value.replace(/^0+/, "")),
          },
          sipStartDate: { value: "" },
          sipEndDate: { value: "" },
          sipDay: { value: "" },
          swpFrequency: { value: "" },
        });
      } else {
        this.setState({
          withdrawals: {
            value: "",
            isError: true,
            errorMessage: !!event.target.value
              ? "no of withdrwals should not be more than 999"
              : "",
          },
          sipStartDate: { value: "" },
          sipEndDate: { value: "" },
          sipDay: { value: "" },
          swpFrequency: { value: "" },
        });
      }
    } else if (!event.target.value) {
      this.setState({
        withdrawals: {
          value: "",
          isError: true,
          errorMessage:
            !!event.target.value && event.target.value !== "0"
              ? "no of withdrawals should not be more than 500"
              : event.target.value === "0"
              ? "no of withdrwals should not be zero"
              : "please enter the minimum no of withdrawals",
        },
        sipStartDate: { value: "" },
        sipEndDate: { value: "" },
        sipDay: { value: "" },
      });
    }
  }
  async handleSwpDay(event) {
    const day = event.target.value;
    this.setState({
      sipDay: { value: day },
    });
    if (day) {
      const params = {
        Fund: this.state.fund.value.value,
        StartDate: day,
        installments: this.state.withdrawals.value,
        Frequency: this.state.swpFrequency.value.FrequencyDescription,
        trtype: "SWP",
        sch: this.state.scheme.value.value.Sch,
      };

      const response = await this.props.CalcSIPEnddt(params);

      const sipStartDateResponse = response.DtData[0].SIP_StartDate;
      const sipEndDateResponse = response.DtData[0].SIP_EndDate;

      if (!!sipEndDateResponse) {
        const reformSIPEndDT = sipEndDateResponse.split("/");
        if (parseFloat(reformSIPEndDT[2]) >= 2099) {
          this.setState({
            sipDay: { value: "" },
            swpFrequency: { value: "" },
            sipStartDate: { value: "" },
            sipEndDate: { value: "" },
            withdrawals: {
              value: "",
              isError: true,
              errorMessage:
                "Your SIP installments are going beyond 2099, select lesser number of installments.",
            },
          });
        } else if (parseFloat(reformSIPEndDT[2]) < 2099) {
          this.setState({
            sipDay: { value: day },
            sipStartDate: { value: sipStartDateResponse },
            sipEndDate: { value: sipEndDateResponse },
          });
        }
      }
    }
  }

  showError = (label) => () => {
    const {
      [label]: { value },
    } = this.state;

    if (label === "withdrawals") {
      this.setState({
        [label]: {
          value,
          isError: this.state.withdrawals.value < 2 ? true : !value,
          errorMessage:
            this.state.withdrawals.value < 2
              ? "Number of withdrawals should be greater than or equal to the minimum number of installments mentioned above"
              : "",
        },
      });
    }
    // else if (label === "amount") {
    //   this.setState({
    //     [label]: {
    //       value,
    //       isError:
    //         this.state.minAmountValue.value < this.state.amount.value
    //           ? true
    //           : !value,
    //       errorMessage:
    //         this.state.minAmountValue.value < this.state.amount.value
    //           ? `Amount should be ${this.state.minAmountValue.value}`
    //           : ""
    //     }
    //   });
    // }
    else {
      this.setState({
        [label]: {
          value,
          isError: !value,
          errorMessage: `${label} is mandatory*`,
        },
      });
    }
  };

  handleMinimumAmount(event) {
    if (event.target.value.length <= 10) {
      this.setState({
        amount: { value: parseFloat(event.target.value.replace(/^0+/, "")) },
      });
    }
  }

  submit = () => {
    let currValue;

    if (!!this.state.scheme.value) {
      currValue = parseFloat(
        this.state.scheme.value.value.CurValue.replace(/,/g, "")
      );
    }
    if (Number(this.state.amount.value) >= currValue) {
      this.setState({
        amount: {
          value: "",
          isError: true,
          errorMessage: "Amount is greater than the current value",
        },
      });
      return;
    }
    if (
      this.state.withdrawals.value * Number(this.state.amount.value) >
      currValue
    ) {
      this.setState({
        amount: {
          value: "",
          isError: true,
          errorMessage: "Installmentwise enter the greater than current value",
        },
      });
      return;
    }

    if (!this.state.amount.value) {
      this.setState({
        amount: {
          value: "",
          isError: true,
          errorMessage: "(Investment amount is mandatory)",
        },
      });
    }
    if (
      !!this.state.scheme.value &&
      !!this.state.amount.value &&
      parseInt(this.state.scheme.value.value.CurValue.replace(/,/g, "")) <
        parseInt(this.state.amount.value)
    ) {
      this.setState({
        amount: {
          value: "",
          isError: true,
          errorMessage: `(Withdrawal amount is more than Current Value)`,
        },
      });
      return;
    }

    const {
      funds,
      folios,
      schemes,
      swpOptions,
      swpFrequencyOptions,
      // withdrawals,
      sipStartDate,
      sipEndDate,
      amount,
      sipCycle,
      bank,
      banks,
      ...others
    } = this.state;
    const keys = Object.keys(others);
    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "sipDay"
                  ? "SWP day"
                  : key === "swpFrequency"
                  ? "With-drawal frequency"
                  : key === "swpOption"
                  ? "With-drawal option"
                  : key === "folio"
                  ? "Folio"
                  : key === "withdrawals"
                  ? "Withdrawals"
                  : key === "scheme"
                  ? "Scheme"
                  : ""
              } is mandatory`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "fund": {
          this.fundField.focus();
          break;
        }
        case "folio": {
          this.folioField.focus();
          break;
        }
        case "scheme": {
          this.schemeField.focus();
          break;
        }
        case "swpOption": {
          this.swpOptionField.focus();
          break;
        }
        case "sipDay": {
          this.sipDayField.focus();
          break;
        }
        case "swpFrequency": {
          this.swpFrquencyField.focus();
          break;
        }
      }
    } else if (this.state.withdrawals.value < 2) {
      this.setState({
        withdrawals: {
          value: "",
          isError: true,
          errorMessage: `Please check the minimum With-drawals value`,
        },
      });
    } else if (
      (parseFloat(this.state.amount.value) < this.state.minAmountValue.value ||
        !this.state.amount.value) &&
      this.state.swpOption.value.Description === "Fixed"
    ) {
      this.setState({
        amount: {
          value: "",
          isError: true,
          errorMessage: `Minimum amount  is ${this.state.minAmountValue.value}(₹)`,
        },
      });
      // }
      //  else {
      //   this.setState({
      //     amount: {
      //       value: "",
      //       isError: true,
      //       errorMessage: "(*Amount should not be greater than  Current Value)"
      //     }
      //   });
      // }
      // return;
    } else {
      const { funds, folios, schemes, swpFrequencyOptions, ...others } =
        this.state;
      this.props.saveTransactionDetails(this.state);
      this.props.history.push({
        pathname: NEW_TRANSACTION_URL + "/swp/digital/transact/confirm",
        state: {
          title: "SWP Payment Summary",
          type: SWP,
          Folio: { value: others.scheme.value.value.Acno },
          withDrawals: others.withdrawals.value,
          scheme: others.scheme.value.value,
          swpFrequency: others.swpFrequency.value,
          sipEndDate: others.sipEndDate.value,
          swpOption: others.swpOption.value,
          sipStartDate: others.sipStartDate.value,
          amount: others.amount.value,
          sipDay: others.sipDay.value,
        },
      });
    }
  };
  render() {
    const {
      funds,
      fund,
      folio,
      folios,
      scheme,
      schemes,
      swpOption,
      swpOptions,
      swpFrequency,
      swpFrequencyOptions,
      withdrawals,
      sipDay,
      sipStartDate,
      sipEndDate,
      sipCycle,
      amount,
    } = this.state;
    return (
      <div className="transaction-details">
        <div className="title">SWP Plan</div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">Folio</div>
          <IntegrationReactSelect
            suggestions={folios.map((item) => ({
              label: item,
              value: item,
            }))}
            disabled={!fund.value}
            value={folio.value}
            placeholder="Select Folio"
            handleChange={this.handleFolioChange}
            inputRef={(ele) => (this.folioField = ele)}
            isError={folio.isError}
            errorMessage={folio.errorMessage}
          />
        </div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">Scheme</div>
          <IntegrationReactSelect
            suggestions={schemes.map((item) => ({
              label: item.PlnDesc
                ? `${item.SchDesc1} - ${item.PlnDesc} - ${item.OptDesc}`
                : item.fm_schdesc,
              value: item,
            }))}
            disabled={!folio.value}
            value={scheme.value}
            placeholder="Select Scheme"
            handleChange={this.handleSchemeChange}
            inputRef={(ele) => (this.schemeField = ele)}
            isError={scheme.isError}
            errorMessage={scheme.errorMessage}
          />
        </div>
        <div className="redemption-details">
          <div className="keys">
            {/* <div>Minimum Amount (₹)</div> */}
            <div>Current Value</div>
          </div>
          <div className="values">
            {/* <div>{!!scheme.value ? scheme.value.value.MinAmt : ""}</div> */}
            <div>{!!scheme.value ? scheme.value.value.CurValue : ""}</div>
          </div>
        </div>
        <div className="input-margin">
          <CustomizedSelect
            name="Withdrawal Option"
            placeholder="Withdrawal Option"
            handleChange={this.handleSwpOptonChange}
            value={swpOption.value}
            disabled
            inputRef={(ele) => (this.swpOptionField = ele)}
            isError={swpOption.isError}
            errorMessage={swpOption.errorMessage}
          >
            {swpOptions.map((item, index) => (
              <MenuItem value={item} key={index}>
                {item.Description}
              </MenuItem>
            ))}
          </CustomizedSelect>
        </div>
        <div className="input-margin">
          <Input
            name="Number of withdrawals (minimum: 2)"
            onChange={(event) => this.handleNoOfWithDrawals(event)}
            onBlur={this.showError("withdrawals")}
            isShowError={withdrawals.isError}
            errorMessage={withdrawals.errorMessage}
            disabled={!scheme.value}
            value={withdrawals.value}
          />
        </div>
        <div className="input-margin">
          <CustomizedSelect
            name="Withdrawal Frequency"
            placeholder="Withdrawal Frequency"
            handleChange={this.handleSwpFrequencyChange}
            value={swpFrequency.value}
            inputRef={(ele) => (this.swpFrquencyField = ele)}
            isError={swpFrequency.isError}
            disabled={!withdrawals.value}
            errorMessage={swpFrequency.errorMessage}
          >
            {swpFrequencyOptions.map((item, index) => (
              <MenuItem value={item} key={index}>
                {item.FrequencyDescription}
              </MenuItem>
            ))}
          </CustomizedSelect>
        </div>
        <div className="input-margin">
          <CustomizedSelect
            name="SWP Date"
            placeholder="SWP Date"
            value={swpFrequency.value ? sipDay.value : ""}
            disabled={!swpFrequency.value}
            inputRef={(ele) => (this.sipDayField = ele)}
            isError={sipDay.isError}
            errorMessage={sipDay.errorMessage}
            handleChange={(event) => this.handleSwpDay(event)}
          >
            {sipCycle.map((item, index) => (
              <MenuItem value={item.sip_cycleid} key={index}>
                {item.sip_cycleid}
              </MenuItem>
            ))}
          </CustomizedSelect>
        </div>
        <div className="input-name">Withdrawal Period</div>
        <div className="input-name">
          <Input
            name="From"
            value={swpFrequency.value ? sipStartDate.value : ""}
            disabled={true}
          />
        </div>

        <div className="input-margin">
          <Input
            name="To"
            value={swpFrequency.value ? sipEndDate.value : ""}
            disabled={true}
          />
        </div>
        {swpOption.value.Description === "Fixed" ? (
          <div>
            <div
              style={{
                margin: "20px 5px 10px",
                color: "#005DAC",
                fontSize: 14,
                backgroundColor: "#fefbf7",
                padding: "10px 0px",
                textAlign: "center",
              }}
            >
              Minimum Amount :
              {!!this.state.minAmountValue
                ? this.state.minAmountValue.value
                : ""}
              (₹)
            </div>
            <div className="input-margin">
              <Input
                name="Amount (₹)"
                onKeyDown={(evt) =>
                  (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                  evt.preventDefault()
                }
                bordercolor="#a6a6a6"
                type="number"
                errorMessage={amount.errorMessage}
                isShowError={amount.isError}
                onBlur={this.showError("amount")}
                // disabled={redemptionType === FULL ? true : false}
                onChange={(event) => this.handleMinimumAmount(event)}
                value={amount.value}
              />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="digital-form-button-next-div">
          <Signbutton buttontitle="Submit" onClick={this.submit} />
        </div>
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const {
      fundList,
      token,
      userId,
      bankDetails,
      investorData,
      communicationDetails,
    } = authReducer;
    const { euinList, transactionDetails } = transactions;
    return {
      fundList,
      token,
      userId,
      euinList,
      bankDetails,
      investorData,
      communicationDetails,
      transactionDetails,
    };
  },
  { swpOptions, CalcSIPEnddt, getMinimumAmount, saveTransactionDetails }
)(Swp);
